import {
    settingsAppAddSuccess,
    settingsAppListSuccess,
    settingsAppUpdateForceSuccess,
    settingsAppDeleteSuccess,
    settingsAppAddError,
    settingsAppListError,
    settingsAppUpdateForceError,
    settingsAppDeleteError,
} from './actions';
import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import { settingsAppAdd, settingsAppList, settingsAppUpdateForce, settingsAppDelete } from '../../helpers/api';
import { SettingsActionTypes } from './constants';
import { SagaIterator } from '@redux-saga/core';

// ADD
function* settingsAppAddSaga(action: any): SagaIterator {
    try {
        const response = yield call(settingsAppAdd, action.payload);
        yield put(settingsAppAddSuccess(response.data));
    } catch (error: any) {
        console.log('error in ADD:', error);
        yield put(settingsAppAddError(error?.response?.data || 'Error Occurred'));
    }
}

// LIST
function* settingsAppListSaga(action: any): SagaIterator {
    try {
        const response = yield call(settingsAppList, action.payload);
        console.log(response);
        yield put(settingsAppListSuccess(response.data.data));
    } catch (error: any) {
        console.log('error in LIST:', error);
        yield put(settingsAppListError(error?.response?.data || 'Error Occurred'));
    }
}

// UPDATE FORCE
function* settingsAppUpdateForceSaga(action: any): SagaIterator {
    try {
        const response = yield call(settingsAppUpdateForce, action.payload);
        yield put(settingsAppUpdateForceSuccess(response.data));
    } catch (error: any) {
        console.log('error in UPDATE FORCE:', error);
        yield put(settingsAppUpdateForceError(error?.response?.data || 'Error Occurred'));
    }
}

// DELETE
function* settingsAppDeleteSaga(action: any): SagaIterator {
    try {
        const response = yield call(settingsAppDelete, action.payload);
        yield put(settingsAppDeleteSuccess(response.data));
    } catch (error: any) {
        console.log('error in DELETE:', error);
        yield put(settingsAppDeleteError(error?.response?.data || 'Error Occurred'));
    }
}

// WATCHERS
function* watchSettingsAppAdd() {
    yield takeEvery(SettingsActionTypes.SETTINGS_APP_ADD, settingsAppAddSaga);
}

function* watchSettingsAppList() {
    yield takeEvery(SettingsActionTypes.SETTINGS_APP_LIST, settingsAppListSaga);
}

function* watchSettingsAppUpdateForce() {
    yield takeEvery(SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE, settingsAppUpdateForceSaga);
}

function* watchSettingsAppDelete() {
    yield takeEvery(SettingsActionTypes.SETTINGS_APP_DELETE, settingsAppDeleteSaga);
}

// ROOT SAGA
function* settingsSaga(): SagaIterator {
    yield all([
        fork(watchSettingsAppAdd),
        fork(watchSettingsAppList),
        fork(watchSettingsAppUpdateForce),
        fork(watchSettingsAppDelete),
    ]);
}

export default settingsSaga;
